<style>
.v-label,
.v-select__selections {
  font-size: 12px !important;
}
</style>

<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="show('addVarianceModal')"
              class="table__btn--green"
            >add_circle</v-icon>
            <p
              class="caption"
              @click="show('addVarianceModal')"
            >DODAJ ROZBIEŻNOŚĆ</p>

            <v-icon
              class="table__btn--blue table__btn--padding"
              v-show="selectedRow"
              @click="openVarianceCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openVarianceCard"
            >OTWÓRZ KARTĘ</p>

            <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >USUŃ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>

            <v-icon
              class="table__btn--padding table__btn--margin-left"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >PRZYBLIŻ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-select
            :items="statuses"
            label="Filtr: status"
            v-model="filterStatus"
            hide-details
            clearable
            @change="filterByStatus(filterStatus)"
            style="padding-right:10px;"
          ></v-select>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    columnDefs: [],
    filter: "",
    filterStatus: "",
    inspectionsTaskFiltered: undefined,
    numberAll: '0',
    numberFiltered: '0',
    selectedRow: undefined,
    statuses: [],
    tableTitle: "variancesTable"
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    getVariances() {
      return this.$store.getters.getVariancesData;
    },
    gridOptions() {
      let gridOptions = {
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        onGridReady: this.onGridReady,
        onFilterChanged: this.filteredNumber,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        rowData: this.loadData(),
      };
      return gridOptions;
    }
  },
  beforeMount() {
    let dict = [
      {
        headerName: "ID",
        field: "id",
        sort: "asc",
        width: 10
      },
      {
        headerName: "Nazwa rozbieżności",
        field: "properties.name"
      },
      {
        headerName: "Status",
        field: "properties.status"
      },
      {
        headerName: "Zgłaszający",
        field: "properties.user_name"
      },
      {
        headerName: "Typ",
        field: "properties.type"
      },
      {
        headerName: "Opis",
        field: "properties.description"
      },
      {
        headerName: "Data zgłoszenia",
        field: "properties.created_at",
        cellRenderer: date => {
          return new Date(date.value).toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
        }
      }
    ];
    dict.forEach(field => {
      this.columnDefs.push(field);
    });
  },
  methods: {
    filterByStatus(value) {
      let statusFilter = this.gridOptions.api.getFilterInstance(
        "properties.status"
      );
      statusFilter.setModel({
        type: "equals",
        filter: value
      });
      this.gridOptions.api.onFilterChanged();
      this.filteredNumber();
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      this.$store.dispatch("getVariances").then(success => {
        this.numberAll = this.getVariances.features.length;
        this.numberFiltered = this.numberAll;
        this.gridOptions.api.setRowData(
          this.$store.getters.getVariancesData.features
        );
      });

      let payload = {
        schema: "registry",
        table: "variances",
        column: "status"
      }
      this.$store.dispatch('getDictSTC', payload).then(r => {
        this.statuses = r.values;
      })
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    openVarianceCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_type: "variances",
        limit: 5,
        events_count: true
      };
      // this.$store.commit("setCurrentVariance", this.selectedRow);
      this.$store.dispatch("getFeatureEvents", payload).then(success => {
        if(success) {
          this.show("varianceCardModal");
          this.$root.$emit('loadVariance', this.selectedRow);
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania danych rozbieżności wystąpił błąd"
          );
        }
      });
    },
    removeRow() {
      const id = this.selectedRow.id;
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie rozbieżności",
        text: "Czy na pewno chcesz usunąć rozbieżność?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store.dispatch("removeVariance", id).then(success => {
                if(success) {
                  this.loadData();
                  this.$root.$emit("removeObjectArea");
                } else {
                  this.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas usuwania rozbieżności wystąpił błąd"
                  );
                }
              });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToGeometry() {
      this.$root.$emit("removeObjectArea");
      this.$root.$emit("addObjectArea", this.selectedRow);
      this.$root.$emit("zoomToArea", [
        this.selectedRow.geometry.coordinates
      ]);
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  mounted() {
    this.$root.$on("edited_variance", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/VariancesTable.vue